/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import * as localForage from 'localforage'
import { webApi } from '../../lib/WebApi'
import {multisportify} from "trux";

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null
}
let lastTeamName = null

const loadTeam = (teamName) => {
    return (dispatch, getState) => {
        if (teamName === 'invite' || teamName === 'tbd' || teamName === 'expelliarmus') {
            return
        }

        let teamState = getState().team
        let tsName = 'not-a-team'
        if (teamState.value) {
            tsName = teamState.value.name
        }
        if (teamState.loading) {
            return { type: 'NOOP' }
        }
        else if (teamState.complete && tsName === teamName) {
            return { type: 'NOOP' }
        }
        else if (teamName === 'expelliarmus' || teamName === 'magic' || teamName === 'unsupported') {
            return { type: 'NOOP' }
        }

        if (tsName !== 'not-a-team' && tsName !== teamName) {
            // full reset the reducers state
            dispatch({
                type: 'COMMON_RESET'
            })
        }

        if (teamName === lastTeamName && teamState.error) {
            return { type: 'NOOP' }
        }

        dispatch({
            type: 'COMMON_SET',
            value:  false,
            key: 'isTeamLoggedIn',
            defaultValue: null
        })
        dispatch({
            type: 'COMMON_SET',
            key: 'team',
            value: { loading: true, error: null },
            defaultValue: {...defaultValue}
        })
        lastTeamName = teamName

        return webApi._get(`/webapp/teams/${teamName}`, { sport_type: 'any' })
           .then(json => {
                json = multisportify(json)
                loadTeamMembers(json, dispatch)

                // cache last used current team
                localForage.setItem('current_team_id', teamName)

                dispatch({
                    type: 'COMMON_SET',
                    key: 'team',
                    value: {
                        loading: false,
                        complete: true,
                        value: json,
                        error: null },
                    defaultValue: defaultValue
                })

                performTeamLogin(json, dispatch)
            })
            .catch(err => {
                console.error('LoadTeam error', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'team',
                    value: {
                        loading: false,
                        complete: true,
                        value: null,
                        error: 'LoadTeam failed'
                    },
                    defaultValue: defaultValue
                })
                // prevent endless reloading of team
                // window.location.hash = '/'
            })

    }
}

const loadTeamMembers = async (team, dispatch) => {
    let members = await webApi.getTeamUsers(team.team_id)
    if (members) {
        team.members = multisportify(members)
        dispatch({
            type: 'COMMON_SET',
            key: 'team',
            value: {
                loading: false,
                complete: true,
                value: team,
                error: null
            },
            defaultValue: defaultValue
        })
    }
}

const performTeamLogin = (team, dispatch) => {

    if (team && team.team_id && team.access_password) {

        webApi.login(team.team_id, team.access_password)
            .then(success => {
                dispatch({
                    type: 'COMMON_SET',
                    value:  success,
                    key: 'isTeamLoggedIn',
                    defaultValue: null
                })
            })
            .catch(err => {
                dispatch({
                    type: 'COMMON_SET',
                    value:  false,
                    key: 'isTeamLoggedIn',
                    defaultValue: null
                })
            })
    }
    else {
        dispatch({
            type: 'COMMON_SET',
            value:  false,
            key: 'isTeamLoggedIn',
            defaultValue: null
        })
    }
}

export default loadTeam
